import React from "react";
import { Modal, Button,Table } from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as alertActions from "../../redux/actions/alertConfirmAction";
import { myUtilities, myGlobals } from "../../Utils";
import ReactHtmlParser from 'react-html-parser';

const AlertConfirmDialogWithCustomMessage = (props) => {
	console.log("props", props);
  let message = myUtilities.accountSpecificLanguagePlaceholders(props.alert.id,props.alert.message,props.alert.value !== undefined ? props.alert.value : {});
  if (message !=undefined && message !=null) {
      message = message.replace(/\n/g, '<br>');
  }
	return (
    <Modal
      show={props.alert.showCustomAlert}
      onHide={() => {
        props.alertActions.hideConfirmAlertAction();

        if (undefined !== props.customFunction) {
          props.customFunction();
        }
      }}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {myUtilities.accountSpecificLanguage(
            props.alert.headerId,
            props.alert.headerDefaultText
          )}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="replace-whitespace">
        {props.alert.value.showGrid &&
        props.alert.value.surchargeResponse != undefined ? (
          <Table>
            <thead>
              <tr>
                <th>Invoice Numbers</th>
                <th>Payment Amount</th>
                {props.alert?.value?.isDiscEnabled !=undefined && props.alert?.value?.isDiscEnabled  && <th>Discount</th>}
                {props.alert?.value?.isLateFeeEnabled !=undefined && props.alert?.value?.isLateFeeEnabled  && <th>Late Fee</th>}
                <th>Surcharge</th>
              </tr>
            </thead>
            <tbody>
              {props.alert.value.surchargeResponse.map((item) => (
                <tr key={item.invoiceNumbers}>
                  <td>
                    {(() => {
                      var invoiceNumbers = item.invoiceNumbers.split(",");
                      var count = invoiceNumbers.length;
                      if (count > 1) {
                        return (
                          <>
                            {invoiceNumbers[0]}{" "}
                            <a href="#" className="invoice-link" title={item.invoiceNumbers}>
                              + {count - 1}
                            </a>
                          </>
                        );
                      } else {
                        return invoiceNumbers[0];
                      }
                    })()}
                  </td>
                  <td>{item.cumulativePayableAmount}</td>
                  {props.alert?.value?.isDiscEnabled !=undefined && props.alert?.value?.isDiscEnabled && <td>{item.cumulativeDiscountAmount}</td>}
                  {props.alert?.value?.isLateFeeEnabled !=undefined && props.alert?.value?.isLateFeeEnabled && <td>{item.cumulativeLateFee}</td>}
                  <td>{`${item.surchargeAmount} (${item.surchargePercentage}%)`}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : null}
        <div>
         {ReactHtmlParser(message)}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={props.onAlertConfirmDialogClick}>
          {myUtilities.accountSpecificLanguage(
            props.alert.okButtonId,
            props.alert.okButtonDefaultText
          )}
        </Button>
        <Button
          variant="secondary"
          onClick={() => {
            props.alertActions.hideConfirmAlertAction();
            myGlobals.paymentMethod = "";
            if (undefined !== props.customFunction) {
              props.customFunction();
            }
          }}
        >
          {myUtilities.accountSpecificLanguage("AlertDialog.Cancel", "Cancel")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
	alert: state.confirmAlert
});

const mapDispatchToProps = (dispatch) => ({
	alertActions: bindActionCreators(alertActions, dispatch)
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(AlertConfirmDialogWithCustomMessage);
